<template>
  <v-snackbar
    v-model="show"
    :timeout="-1"
    color="info"
    top
  >
    <div class="d-flex align-center">
      <v-icon left dark>mdi-update</v-icon>
      <span>New version available!</span>
    </div>
    
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        dark
        v-bind="attrs"
        @click="refreshApp"
      >
        Refresh
      </v-btn>
      <v-btn
        icon
        dark
        v-bind="attrs"
        @click="show = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import pwaService from '@/services/pwaService';

export default {
  name: 'UpdateNotification',
  
  data() {
    return {
      show: false,
      registration: null
    };
  },
  
  mounted() {
    pwaService.onUpdateAvailable(this.handleUpdate);
  },
  
  methods: {
    handleUpdate(registration) {
      this.registration = registration;
      this.show = true;
    },
    
    refreshApp() {
      this.show = false;
      
      if (this.registration && this.registration.waiting) {
        // Send message to skip waiting
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      
      // Reload the page after a tiny delay
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }
};
</script>